import * as ROUTES from './routes';

export type PageSettingsKey = 'AccountSummary' | 'Invoices' | 'Payments' | 'Statements';

export const PAGE_SETTINGS_ROUTE_MAP: Record<PageSettingsKey, string> = {
  AccountSummary: ROUTES.HOME,
  Invoices: ROUTES.INVOICES,
  Payments: ROUTES.PAYMENTS,
  Statements: ROUTES.STATEMENTS
};

export const DEFAULT_ACADEMIC_YEAR_FILTER_SETTINGS = {
  allowUserToChangeDropdownValue: true,
  showAllOption: false
};
